import { View } from 'react-native'
import Button from '@ui/buttons/Button'
import { ButtonProps } from '@ui/buttons/Button/types'
import Typography from '@ui/typography'
import Border from '@ui/effects/Border'
import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'
import Animated from 'react-native-reanimated'
import cn from '@ui/utils/cn'
import { header } from '@ui/theme/values'

interface Props {
  title: string
  desc: string
  children?: React.ReactNode
  button?: ButtonProps
  classNameOuter?: string
  disableAnimation?: boolean // TODO: DEPRECATED, remove it
}

export default function EmptyResult({
  title,
  desc,
  button,
  children,
}: // disableAnimation,
Props) {
  return (
    <Animated.View
      className={cn('overflow-hidden rounded-2xl')}
      // entering={!disableAnimation ? FadeIn.duration(500).delay(250) : undefined}
      // exiting={!disableAnimation ? FadeOut.duration(100) : undefined}
    >
      <Gradient
        colors={[colors.white, colors.gray[75]]}
        start={[0, 0]}
        end={[1, 1]}
      />
      <Border />
      <View className="flex w-full flex-1 flex-col items-center justify-center gap-12 p-16 pb-20">
        <View className="flex flex-col items-center justify-center gap-6">
          <Typography variant="XLB" className="text-center">
            {title}
          </Typography>
          <Typography
            variant="MD"
            className="color-desc text-center"
            style={{ maxWidth: header.description.maxWidth }}
          >
            {desc}
          </Typography>
        </View>
        {children}
        {button && <Button variant="filled" size="md" {...button} />}
      </View>
    </Animated.View>
  )
}
